import { useState } from 'react';
import axiosJWT from '../../secureAPI/axiosJWT';
const useMutation = () => {

    // const axiosJWT = Axios.create();
    // axiosJWT.interceptors.request.use(async (config) => {
    //   // const accessToken = localStorage.getItem('authToken');
    //   if (accessToken) {
    //     config.headers.Authorization = `Bearer ${accessToken}`;
    //   }
    //   return config;
    // }, (error) => {
    //   return Promise.reject(error);
    // });
    const [mystate, setMystate] = useState({
        isLoading: false,
        error: '',
    });
    // Construct the URL dynamically using the environment variable
    const url = `${process.env.REACT_APP_API_URL}/api/UploadDocExcel`;

    // Set up the method and data (assuming you have these variables already defined)
    const method = 'POST'; // or 'GET', depending on your needs
    const fn = async data => {
        setMystate(prev => ({
            ...prev, isLoading: true,
        }));
        // await axiosJWT({ , method, data, withCredentials: true, credentials: 'include'})
        axiosJWT(url, {
            method: method,
            data: data,
            withCredentials: true,  // This ensures that cookies are sent with the request
            credentials: 'include'  // This is typically for cross-origin requests, ensuring credentials are included
        })
            .then(() => { setMystate({ isLoading: false, error: '' }) })
            .catch(error => { setMystate({ isLoading: false, error: error.message }) });
    }
    return { mutate: fn, ...mystate };
}

export default useMutation
